import { useContext } from "react";
import { ProjectOutlined, ReadOutlined } from '@ant-design/icons';
import ProgressComponent from "../../components/ProgressComponent";
import { SubContainer } from "./styled";
import { AppContext } from "../../utils/AppContext";
import { USER_ROLE } from "../../constants";

const ProgressContainer = () => {
    const { userInfo } = useContext(AppContext);
    let sessionId = localStorage.getItem("sessionId");
    return (
        <SubContainer>
           { userInfo.user_role !== USER_ROLE.STUDENT && <ProgressComponent icon={<ProjectOutlined />} title="Students" color="#90C226" link="team" /> } 
            <ProgressComponent icon={<ReadOutlined />} title="Precimar ULM 600-E" color="#54A021" link={`precimar_ulm_600_e/${sessionId}`} />
        </SubContainer>
    );
}

export default ProgressContainer;